<template>
	<a
		class="nav-meta__list-item-link"
		@click.prevent="onClick"
		href="javascript:void(0)"
	>
		<span
			class="nav-meta__list-item-text"
			v-if="!isLoggedIn"
			v-html="$t('login.iconLabel')"
		/>
		<SVGUser
			class="nav-meta__list-item-icon nav-meta__list-item-icon--closed"
		/>
		<SVGClose
			class="nav-meta__list-item-icon nav-meta__list-item-icon--opened"
		/>
	</a>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from "htmlcomponent"


export default {
	mixins: [],
	components: {},
	data() {
		return {
			overlayType: 'login',
		};
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
		])
	},
	methods: {
		onClick() {
			if (this.isLoggedIn) {
				htmlComponent.send('overlay:close', {type: this.overlayType});
				this.$store.dispatch('redirect', {name: 'account'})
			} else {
				htmlComponent.send('overlay:toggle', {type: this.overlayType});
			}
		}
	}
}
</script>

<style></style>
